import PrintInvoice from './PrintInvoice'

export default {
  PrintInvoice
}



// WEBPACK FOOTER //
// ./src/components/PrintPdf/index.js